import { getTranslations } from "../../Common/utils";
import LeagueTypeIcon from "../Cloudinary/LeagueTypeIcon";

const LeaguePreview = ({
  leagueName = "",
  placeholderText = null,
  leagueType = null,
  leagueTypeBackgroundImage = null,
}) => {
  const displayLeagueName =
    decodeURIComponent(leagueName) ||
    placeholderText ||
    getTranslations("lbl_league_title", "League Title");

  const backgroundStyles = leagueTypeBackgroundImage
    ? {
        backgroundImage: `url(${leagueTypeBackgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }
    : {};

  return (
    <div className="si-createLeague__preview" style={backgroundStyles}>
      <div className="si-createLeague__preview-content">
        <div className="si-createLeague__preview-icon">
          <LeagueTypeIcon type={leagueType} />
        </div>
        <div className="si-createLeague__preview-name">{displayLeagueName}</div>
        <div className="si-createLeague__preview-type">{leagueType}</div>
      </div>
    </div>
  );
};

export { LeaguePreview };
